import type { ComponentMultiStyle } from "@yamada-ui/core"

export const List: ComponentMultiStyle<"List"> = {
  baseStyle: {
    container: {},
    icon: {
      display: "inline-block",
      me: "2",
      verticalAlign: "middle",
    },
    item: {},
  },
}
